import React, { useEffect, useState } from "react";
import Sidebar from "../../../../components/user/defaultLayout/Sidebar";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import DataService, {
  API_ENDPOINT,
  imagePath,
} from "../../../../config/DataService";
import { toast } from "react-toastify";
import { Api } from "../../../../config/Api";
import moment from "moment";
import dayjs from "dayjs";
import {
  getAllFamilyWithMohollaNameAndAreaList,
  getCheckAuthenticationDocument,
} from "../../../../redux/features/AddService";
import axios from "axios";
const ariaLabel = { "aria-label": "description" };
const ApplyForSahayView = () => {
  const { sahayApplicationAdminSingleGet } = PagesIndex.useSelector(
    (state) => state.admin
  );
  const [familyListWithArea, setFamilyListWithArea] = useState([]);
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const { state } = PagesIndex.useLocation();
  const [blobImageUrl, setBlobImgUrl] = useState(null);
  const [getViewData, setGetViewData] = useState(null);

  const initialValues = {};

  const openSecureImageWithAuth = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        const blobUrl = URL.createObjectURL(imageRes.data);
        const ComponentData = "viewsahay";
        navigate("/image-view", {
          state: {
            blobUrl,
            docImageData,
            state,
            ComponentData,
          },
        });
      } else {
        toast.error("Signed URL not received.");
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  const renderDocument = (url, filename) => {
    let extension = "";

    if (filename) {
      extension = filename.split(".").pop().toLowerCase();
    } else if (url && url.startsWith("blob:")) {
      extension = ""; // Blob URL cannot detect type without filename
    } else if (url) {
      extension = url.split(".").pop().toLowerCase();
    }
    if (["png", "jpg", "jpeg", "gif", "webp"].includes(extension)) {
      return <img src={url} alt="Document" className="fullscreen-image" />;
    } else if (extension === "pdf") {
      return (
        <iframe
          src={url}
          title="PDF Document"
          className="fullscreen-pdf"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else if (["doc", "docx"].includes(extension)) {
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
            url
          )}`}
          title="Word Document"
          className="fullscreen-doc"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      );
    } else {
      return <p style={{ color: "#fff" }}>Unsupported or Unknown file type</p>;
    }
  };

  const openSecureImageWithAuthWithoutNavigate = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;
      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        setBlobImgUrl(blobUrl);
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };
  console.log("getViewData==getViewData", getViewData?.application[0]?.image);
  useEffect(() => {
    openSecureImageWithAuthWithoutNavigate(getViewData?.application[0]?.image);
  }, [getViewData?.application[0]?.image]);

  // const openSecureImageWithAuth = async (filename) => {
  //   try {
  //     const token = localStorage.getItem("commonToken");

  //     // Step 1: Get encrypted image URL from backend
  //     const res = await axios.get(`${API_ENDPOINT}generate-image-url/${filename}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const signedUrl = res?.data?.url;

  //     if (signedUrl) {
  //       // Step 2: Fetch image blob manually with token
  //       const imageRes = await axios.get(signedUrl, {
  //         headers: {
  //           Authorization: `Bearer ${token}`, // ✅ token for /protected-image
  //         },
  //         responseType: "blob",
  //       });

  //       // Step 3: Convert blob to object URL
  //       const blobUrl = URL.createObjectURL(imageRes.data);
  //       window.open(blobUrl, "_blank"); // ✅ safe open, URL not exposed
  //     } else {
  //       toast.error("Could not generate secure image URL.");
  //     }
  //   } catch (error) {
  //     console.error("Image open error:", error);
  //     toast.error("Failed to open image.");
  //   }
  // };

  const getSingleSahayApplication = async () => {
    try {
      const response = await DataService.get(
        `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.id}`
        // `${Api.GET_SINGLE_SAHAY_APPLICATION}/${state.id[0]}`
      );
      setGetViewData(response.data.data);
    } catch (error) {
      // toast.error(error.response.data.message || error.message);
    }
  };
  useEffect(() => {
    getSingleSahayApplication();
  }, []);

  //back button
  const handleBack = () => {
    navigate("/user/user-listing");
  };

  //Get current financial year
  function getCurrentFinancialYear() {
    var financialYear = "";
    var today = new Date();
    if (today.getMonth() + 1 <= 3) {
      financialYear = today.getFullYear() - 1 + "-" + today.getFullYear();
    } else {
      financialYear = today.getFullYear() + "-" + (today.getFullYear() + 1);
    }
    return financialYear;
  }

  const getFamilyListWithArea = () => {
    const data = {
      mobile: getViewData?.application[0]?.patanMemberMobile,
    };
    dispatch(getAllFamilyWithMohollaNameAndAreaList(data)).then((res) => {
      if (res?.payload) {
        setFamilyListWithArea(res?.payload?.data);
      } else {
        setFamilyListWithArea([]);
      }
    });
  };

  useEffect(() => {
    if (getViewData?.application[0]?.patanMemberMobile?.length >= 10) {
      getFamilyListWithArea();
    }
  }, [getViewData?.application[0]?.patanMemberMobile]);

  return (
    <>
      <Index.Box className="apply-sahay-main">
        <Sidebar />
        <Index.Box className="head-content">
          <Index.Box className="user-right">
            <Index.Box className="bottom-user-right">
              <Index.Box className="page-content-box">
                <Index.Box className="barge-common-box">
                  <Index.Box className="title-header">
                    <Index.Box className="title-header-flex">
                      <Index.Box className="title-main mb-10">
                        <Index.Typography
                          variant="p"
                          component="p"
                          className="page-title"
                        >
                          View Sahay Application
                        </Index.Typography>
                      </Index.Box>
                      <Index.Box sx={{ marginTop: "40px" }}>
                        <Index.Box className="title-header-flex text-end-details">
                          <Index.Box className="common-button blue-button flex-start save-btn  ">
                            <Index.Button
                              variant="contained"
                              onClick={() => handleBack()}
                            >
                              Back
                            </Index.Button>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>

                  <PagesIndex.Formik
                    initialValues={initialValues}
                    enableReinitialize
                  >
                    {({ values }) => (
                      <form>
                        <Index.Box className="">
                          <Index.Grid container spacing={3}>
                            {getViewData?.application[0]?.image && (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label "
                                >
                                  Image
                                </Index.Typography>
                                <Index.Box
                                  className=" mb-5 mt-5"
                                  style={{
                                    width: "120px",
                                    height: "120",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    openSecureImageWithAuth(
                                      getViewData?.application[0]?.image
                                    )
                                  }
                                >
                                  {renderDocument(
                                    blobImageUrl,
                                    getViewData?.application[0]?.image
                                  )}
                                  {/* {getViewData?.application[0]?.image && (
                                    <img
                                      style={{ width: "120px", height: "120" }}
                                      src={`${imagePath}${getViewData?.application[0]?.image}`}
                                      className="  mb-5 mt-5"
                                    />
                                  )} */}
                                </Index.Box>
                              </Index.Grid>
                            )}

                            {getViewData?.document
                              ?.map((data) => ({
                                documentType: data.documentType,
                                documents: data.documents?.filter(
                                  (doc) => doc.document !== "null"
                                ),
                              }))
                              ?.filter((item) => item.documents?.length > 0)
                              .length > 0 ? (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Documents (દસ્તાવેજો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>

                                <Index.Grid item xs={8}>
                                  <Index.Box className="select-view-document-name">
                                    <Index.Box className="select-view-document-name mt-select-doc">
                                      {/* <Index.Box className="select-view-document-name mt-select-doc">
                                  {getViewData?.document
                                    ?.map((data) =>
                                      data?.documents?.filter(
                                        (ele) => ele?.document !== "null"
                                      )
                                    )
                                    .map((item, fileIndex) => {
                                      return (
                                        <>
              
                                          {item?.documentType  &&
                                            item?.documents?.length > 0 && (
                                              <Index.Box className="roles-data-box add-check-flex-doc">
                                                <Index.Box className="add-role-flex">
                                                  <Index.Box className="role-data-title">
                                                    {item.documentType}
                                                  </Index.Box>
                                                </Index.Box>
                                              </Index.Box>
                                            )}
                                          {item?.documents
                                            ?.filter(
                                              (ele) => ele?.document !== "null"
                                            )
                                            .map((document, documentIndex) => (
                                              <Index.Box
                                              className="select-view-document-name mt-select-doc"
                                              key={documentIndex}
                                              >
                                       
                                                <Index.Box className="document-name">
                                                  <Index.Typography
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      window.open(
                                                        document instanceof Blob
                                                          ? URL.createObjectURL(
                                                              document
                                                            )
                                                          : `${imagePath}${document?.filename}`
                                                      );
                                                    }}
                                                  >
                                                    {document instanceof Blob
                                                      ? document.name
                                                      : document?.document}
                                                  </Index.Typography>
                                                  <Index.IconButton
                                                    onClick={() => {
                                                
                                                      // Implement your logic to remove the document
                                                    }}
                                                  >
                                                    <Index.ClearIcon className="muiico-cancel" />
                                                  </Index.IconButton>
                                                </Index.Box>
                                              </Index.Box>
                                            ))}
                                        </>
                                      );
                                    })}
                                </Index.Box> */}

                                      {getViewData?.document
                                        ?.map((data) => ({
                                          documentType: data.documentType,
                                          documents: data.documents?.filter(
                                            (doc) =>
                                              doc.document !== "null" &&
                                              doc.document !== "demo.png"
                                          ),
                                        }))
                                        ?.filter(
                                          (item) => item.documents?.length > 0
                                        )
                                        ?.map((item, fileIndex) => (
                                          <div key={fileIndex}>
                                            <Index.Box className="roles-data-box add-check-flex-doc">
                                              <Index.Box className="add-role-flex">
                                                <Index.Box className="role-data-title">
                                                  {item.documentType}
                                                </Index.Box>
                                              </Index.Box>
                                            </Index.Box>

                                            {/* Documents List */}
                                            <div>
                                              {item.documents.map(
                                                (document, documentIndex) => (
                                                  <Index.Box
                                                    className="select-view-document-name mt-select-doc"
                                                    key={documentIndex}
                                                  >
                                                    <Index.Box className="document-name">
                                                      <Index.Typography
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          openSecureImageWithAuth(
                                                            document?.filename
                                                          )
                                                        }
                                                      >
                                                        {document instanceof
                                                        Blob
                                                          ? document.name
                                                          : document?.document ||
                                                            document?.filename}
                                                      </Index.Typography>
                                                    </Index.Box>
                                                  </Index.Box>
                                                )
                                              )}
                                            </div>
                                          </div>
                                        ))}
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            ) : (
                              ""
                            )}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Basic Details (મૂળભૂત વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Family ID (કૌટુંબિક આઈડી)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="familyId"
                                  disabled
                                  value={state?.mem_family_id}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Addhar Card No. (આધાર કાર્ડ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.AadharNo}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Sahay Category (શાખાનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Sahay Category"
                                  disabled
                                  value={getViewData?.application[0]?.SahayName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Sub Sahay Category (સબ સહાય પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Sahay Category"
                                  disabled
                                  value={
                                    getViewData?.application[0]?.subSahayName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Year Of Sahay (સહાયનું વર્ષ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.Year || "-"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            {getViewData?.application[0]?.PANCardNo ? (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  PAN CARD No. (વિસ્તાર)
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    disabled
                                    // value={getViewData?.application[0]?.workingType}
                                    value={
                                      getViewData
                                        ? getViewData?.application?.[0]
                                            ?.PANCardNo
                                        : getViewData?.application?.[0]
                                            ?.PANCardNo
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            ) : (
                              <></>
                            )}

                            {getViewData?.application[0]?.subSahayName ==
                              "Medical Sahay" &&
                            getViewData?.application[0]?.disease !== null ? (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Type Of Disease
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Addharcard No."
                                    value={
                                      getViewData?.application[0]?.subSahayName
                                        ?.typeOfDisease
                                    }
                                    disabled
                                  />
                                </Index.Box>
                              </Index.Grid>
                            ) : null}

                            {/* <Index.Grid item xs={12} sm={6} md={3}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Application Received Date
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border date-input-box">
                                <Index.LocalizationProvider
                                  dateAdapter={Index.AdapterDayjs}
                                  sx={{ position: "absolute" }}
                                >
                                  <Index.DemoContainer
                                    components={["DatePicker"]}
                                  >
                                    <Index.DatePicker
                                      name="applicationReceiveDate"
                                      // onChange={(value) => {
                                      //   setFieldValue(
                                      //     "applicationReceiveDate",
                                      //     moment(value.$d).format(
                                      //       "YYYY-MM-DD"
                                      //     )
                                      //   );
                                      // }}
                                      value={dayjs(
                                        getViewData?.application[0]
                                          ?.applicationReceiveDate
                                      )}
                                      format="YYYY-MM-DD"
                                      sx={{
                                        overflowY: "hidden",
                                        position: "relative",
                                        bottom: "8px",
                                        width: "100%",
                                      }}
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          error: false,
                                        },
                                      }}
                                    />
                                  </Index.DemoContainer>
                                </Index.LocalizationProvider>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={3}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Filing Date
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border date-input-box">
                                <Index.LocalizationProvider
                                  dateAdapter={Index.AdapterDayjs}
                                  sx={{ position: "absolute" }}
                                >
                                  <Index.DemoContainer
                                    components={["DatePicker"]}
                                  >
                                    <Index.DatePicker
                                      name="formFillingDate"
                                      // onChange={(value) => {
                                      //   setFieldValue(
                                      //     "formFillingDate",
                                      //     moment(value.$d).format(
                                      //       "YYYY-MM-DD"
                                      //     )
                                      //   );
                                      // }}
                                      value={dayjs(
                                        getViewData?.application[0]
                                          ?.formFillingDate
                                      )}
                                      format="YYYY-MM-DD"
                                      sx={{
                                        overflowY: "hidden",
                                        position: "relative",
                                        bottom: "8px",
                                        width: "100%",
                                      }}
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          error: false,
                                        },
                                      }}
                                    />
                                  </Index.DemoContainer>
                                </Index.LocalizationProvider>
                              </Index.Box>
                              {/* {errors?.applicationreceivedate &&
                                  touched.applicationreceivedate && (
                                    <p className="error-text">
                                      {errors?.applicationreceivedate}
                                    </p>
                                  )} 
                            </Index.Grid> */}
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Family Members Details (પરિવારના સભ્યોની
                                      વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                First Name (પ્રથમ નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={getViewData?.application[0]?.firstName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Middle Name (મધ્યમ નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={
                                    getViewData?.application[0]?.middleName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Last Name (છેલ્લું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="User Name"
                                  disabled
                                  value={getViewData?.application[0]?.lastName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Relation (સંબંધ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.relation}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Age (ઉંમર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.age
                                      ? getViewData?.application[0]?.age
                                      : "----"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Working Type (કામનો પ્રકાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.workingType
                                      ? getViewData?.application[0]?.workingType
                                      : "----"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Beneficiary Name (લાભાર્થીનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.beneficiaryMemName
                                      : getViewData?.application?.[0]
                                          ?.beneficiaryMemName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Family Income (કૌટુંબિક આવક){" "}
                                <span className="required">*</span>
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.monthlyIncome
                                      : getViewData?.application?.[0]
                                          ?.monthlyIncome
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Electric Bill amount (ઇલેક્ટ્રિક બિલની રકમ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={getViewData?.application[0]?.workingType}
                                  value={
                                    getViewData
                                      ? getViewData?.application?.[0]
                                          ?.threeMonthBillAmount
                                      : getViewData?.application?.[0]
                                          ?.threeMonthBillAmount || "-"
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Bank Details (બેંક વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Bank Name (બેંકનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.bankName}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Branch (શાખા)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.branch}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Account Holder Name (એકાઉન્ટ ધારકનું નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]?.HolderName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Account Number (એકાઉન્ટ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.AccountNo}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                IFSC code (IFSC કોડ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={getViewData?.application[0]?.IFSCCode}
                                />
                              </Index.Box>
                            </Index.Grid>
                            {getViewData?.application[0]?.mediclaimAmmount !==
                              0 ||
                            getViewData?.application[0]?.SahayAmmount !== 0 ||
                            getViewData?.application[0]?.rentSahayAmmount !==
                              0 ||
                            getViewData?.application[0]?.claimedAmmount !==
                              0 ? (
                              <Index.Grid item xs={12} sm={12} md={12}>
                                <Index.Box className="title-header">
                                  <Index.Box className="title-header-flex">
                                    <Index.Box className="title-main ">
                                      <Index.Typography
                                        variant="p"
                                        component="p"
                                        className="page-title"
                                      >
                                        Sahay Details (સહાય વિગતો)
                                      </Index.Typography>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Grid>
                            ) : (
                              <></>
                            )}

                            {getViewData?.application[0]?.mediclaimAmmount !==
                              0 && (
                              <>
                                {" "}
                                {/* <Index.Grid item xs={12} sm={6} md={5} lg={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Mediclaim Policy Amount
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.mediclaimAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>{" "} */}
                              </>
                            )}
                            {getViewData?.application[0]?.SahayAmmount !==
                              0 && (
                              <Index.Grid item xs={12} sm={6} md={3}>
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Sahay Amount
                                </Index.Typography>
                                <Index.Box className="input-design-div with-border">
                                  <Index.TextField
                                    hiddenLabel
                                    id="filled-hidden-label-normal"
                                    variant="filled"
                                    className="admin-input-design input-placeholder"
                                    autoComplete="off"
                                    name="Sahay Amount"
                                    disabled
                                    value={
                                      getViewData?.application[0]?.SahayAmmount
                                    }
                                  />
                                </Index.Box>
                              </Index.Grid>
                            )}
                            {getViewData?.application[0]?.rentSahayAmmount !==
                              0 && (
                              <>
                                <Index.Grid item xs={12} sm={6} md={3}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    Rent Amount For Rent Sahay
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.rentSahayAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            )}
                            {getViewData?.application[0]?.claimedAmmount !==
                              0 && (
                              <>
                                <Index.Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Total Requested Sahay Amount (કુલ વિનંતી
                                    કરેલ સહાય રકમ)
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.claimedAmmount
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>{" "}
                              </>
                            )}
                            <Index.Grid item xs={12} sm={8} md={8}>
                              <Index.Box className="lable-input-grp">
                                <Index.Typography
                                  variant="label"
                                  component="label"
                                  className="input-label"
                                >
                                  Remark (ટિપ્પણી)
                                </Index.Typography>
                                {/* <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="remark"
                                        value={values?.remark}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      /> */}
                                <Index.TextareaAutosize
                                  style={{
                                    fontSize: "15px",
                                    color: "black",
                                    padding: "4px",
                                    minHeight: "50px",
                                    width: "100%",
                                  }}
                                  minRows={1}
                                  inputProps={ariaLabel}
                                  className="basic-input input-width"
                                  name="remark"
                                  value={getViewData?.application[0]?.remark}

                                  // onBlur={handleBlur}
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex">
                                  <Index.Box className="title-main ">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Reference / Guarantor (સંદર્ભ / બાંયધરી
                                      આપનાર)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Mobile Number (મોબાઈલ નંબર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  value={
                                    getViewData?.application[0]
                                      ?.patanMemberMobile
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                FID (કૌટુંબિક આઈડી)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.mem_family_id
                                  //     : ""
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile
                                        )?.mem_family_id
                                      : ""
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Reference / Guarantor (સંદર્ભ / બાંયધરી આપનાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? `${getViewData?.PatanMemberData?.[0]?.mem_fname} ${getViewData?.PatanMemberData?.[0]?.mem_mname} ${getViewData?.PatanMemberData?.[0]?.mem_lname}`
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceName
                                  // }

                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile
                                    )
                                      ? `${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.mem_fname
                                        } ${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.mem_mname
                                        } ${
                                          familyListWithArea.find(
                                            (row) =>
                                              row?.mem_mobile ==
                                              getViewData?.application[0]
                                                ?.patanMemberMobile
                                          )?.mem_lname
                                        }`
                                      : values?.patanReferenceName
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Mohalla Name (મહોલ્લો નામ)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.mohollo_name
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceMohollo
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile
                                        )?.mohollo_name
                                      : values?.patanReferenceMohollo
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>
                            <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                              <Index.Typography
                                variant="label"
                                component="label"
                                className="input-label"
                              >
                                Area (વિસ્તાર)
                              </Index.Typography>
                              <Index.Box className="input-design-div with-border">
                                <Index.TextField
                                  hiddenLabel
                                  id="filled-hidden-label-normal"
                                  variant="filled"
                                  className="admin-input-design input-placeholder"
                                  autoComplete="off"
                                  name="Addharcard No."
                                  disabled
                                  // value={
                                  //   getViewData?.application[0]
                                  //     ?.patanMandalMember
                                  //     ? getViewData?.PatanMemberData?.[0]
                                  //       ?.family_area
                                  //     : getViewData?.application[0]
                                  //       ?.patanReferenceArea
                                  // }
                                  value={
                                    familyListWithArea?.find(
                                      (row) =>
                                        row?.mem_mobile ==
                                        getViewData?.application[0]
                                          ?.patanMemberMobile
                                    )
                                      ? familyListWithArea?.find(
                                          (row) =>
                                            row?.mem_mobile ==
                                            getViewData?.application[0]
                                              ?.patanMemberMobile
                                        )?.family_area
                                      : values?.patanReferenceArea
                                  }
                                />
                              </Index.Box>
                            </Index.Grid>

                            <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Family Members Details (પરિવારના સભ્યોની
                                      વિગતો)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table "
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell>
                                          Name (નામ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Age (ઉંમર)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Relation (સંબંધ)
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Working Type (કામ કરવાનો પ્રકાર)
                                        </Index.TableCell>
                                        {/* <Index.TableCell align="left">
                                          {" "}
                                          Monthly Income
                                        </Index.TableCell> */}
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.relationRecords?.length ? (
                                        getViewData?.relationRecords?.map(
                                          (data, index) => {
                                            return (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell>
                                                  {data?.name}
                                                </Index.TableCell>

                                                <Index.TableCell align="left">
                                                  {data?.age}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.relation}
                                                </Index.TableCell>
                                                <Index.TableCell align="left">
                                                  {data?.workingType}
                                                </Index.TableCell>
                                                {/* <Index.TableCell align="left">
                                                  {data?.monthlyIncome}
                                                </Index.TableCell> */}
                                              </Index.TableRow>
                                            );
                                          }
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={6}
                                            align="center"
                                          >
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid>
                            {/* <Index.Grid item xs={12} md={12}>
                              <Index.Box className="title-header">
                                <Index.Box className="title-header-flex res-title-header-flex">
                                  <Index.Box className="title-main">
                                    <Index.Typography
                                      variant="p"
                                      component="p"
                                      className="page-title"
                                    >
                                      Trust
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>
                              </Index.Box>
                              <Index.Box className="">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table-design-main barge-table "
                                  >
                                    <Index.TableHead>
                                      <Index.TableRow>
                                        <Index.TableCell align="left">
                                          Trust Name
                                        </Index.TableCell>
                                        <Index.TableCell align="left">
                                          {" "}
                                          Account
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody>
                                      {getViewData?.trustRecords?.length ? (
                                        getViewData?.trustRecords?.map(
                                          (data, index) => {
                                            return (
                                              <Index.TableRow key={index}>
                                                <Index.TableCell align="left">
                                                  {data?.trustName}
                                                </Index.TableCell>

                                                <Index.TableCell align="left">
                                                  {data?.ammount}
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            );
                                          }
                                        )
                                      ) : (
                                        <Index.TableRow>
                                          <Index.TableCell
                                            component="td"
                                            variant="td"
                                            scope="row"
                                            className="no-data-in-list"
                                            colSpan={2}
                                            align="center"
                                          >
                          
                                            No data available
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      )}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Grid> */}
                            {getViewData?.application[0]?.committeeRemark ||
                            getViewData?.application[0]?.staffRemark ? (
                              <>
                                <Index.Grid item xs={12} sm={12} md={12}>
                                  <Index.Box className="title-header">
                                    <Index.Box className="title-header-flex">
                                      <Index.Box className="title-main ">
                                        <Index.Typography
                                          variant="p"
                                          component="p"
                                          className="page-title"
                                        >
                                          Remarks
                                        </Index.Typography>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={6} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Committee Remark
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.committeeRemark || "-"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={6} sm={6} md={6} lg={6}>
                                  <Index.Typography
                                    variant="label"
                                    component="label"
                                    className="input-label"
                                  >
                                    {/* Claimed Sahay Amount */}
                                    Staff Remark
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border">
                                    <Index.TextField
                                      hiddenLabel
                                      id="filled-hidden-label-normal"
                                      variant="filled"
                                      className="admin-input-design input-placeholder"
                                      autoComplete="off"
                                      name="Addharcard No."
                                      disabled
                                      value={
                                        getViewData?.application[0]
                                          ?.staffRemark || "-"
                                      }
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </>
                            ) : (
                              <></>
                            )}

                            {/* table */}
                          </Index.Grid>

                          <Index.Box className="line" mt={3} mb={3}></Index.Box>
                        </Index.Box>
                      </form>
                    )}
                  </PagesIndex.Formik>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>
    </>
  );
};

export default ApplyForSahayView;
